import { FC } from "react";

import { FormSkeleton, FormSkeletonProps } from "@/forms-design-system/FormSkeleton";

type FormCampaignTargetThermometerSkeletonProps = Omit<FormSkeletonProps, "variant" | "width" | "height">;

export const FormCampaignTargetThermometerSkeleton: FC<FormCampaignTargetThermometerSkeletonProps> = ({ ...rest }) => {
  return <FormSkeleton {...rest} variant="rounded" width="100%" height={60} />;
};
